import Vue from "vue";
import Vuex from "vuex";
import gateway from "@/services/gateway";
import errors from "@/services/errors";
//import axios from "axios";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    subscription: null,
    customer: null,
    cardDetails: null
  },
  mutations: {
    SET_SUBSCRIPTION(state, payload) {
      state.subscription = payload;
    },
    SET_CUSTOMER(state, payload) {
      state.customer = payload;
    },
    SET_CARD_DETAILS(state, payload) {
      state.cardDetails = payload;
    }
  },
  actions: {
    async load({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/subscriptions/${id}`);
        if (!res) throw new Error("No se pudo cargar la suscripción.");
        commit("SET_SUBSCRIPTION", res.data);
        return res.data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async loadCustomer({ commit }, id) {
      try {
        const res = await Vue.prototype.$axios.get(`/customers/${id}`);
        if (res.status != 200) {
          const err = errors.handleHTTPError(res);
          throw err;
        }
        commit("SET_CUSTOMER", res.data);
        return res.data;
      } catch (err) {
        throw err;
      }
    },
    async saveCustomer({ commit }, { email, firstName, lastName, phone1 }) {
      try {
        const res = await Vue.prototype.$axios.post(`/customers`, {
          email,
          firstName,
          lastName,
          phone1
        });
        if (res.status != 201) {
          const err = errors.handleHTTPError(res);
          throw err;
        }
        commit("SET_CUSTOMER", res.data);
        return res.data.id;
      } catch (err) {
        throw err;
      }
    },
    async subscribe({ commit, state }, payload) {
      try {
        let subscribeRes;
        if (payload.paymentCardId) {
          subscribeRes = await Vue.prototype.$axios.post(
            `/subscriptions/${state.subscription.id}/subscribers/${state.customer.id}`,
            {
              paymentCardId: payload.paymentCardId
            }
          );
        } else {
          subscribeRes = await Vue.prototype.$axios.post(
            `/subscriptions/${state.subscription.id}/subscribers/${state.customer.id}`,
            {
              tempToken: payload.tempToken,
              paymentCourierId: payload.paymentCourierId,
              cardBin: payload.cardBin,
              lastFourDigits: payload.lastFourDigits,
              cardSecurityCode: payload.cardSecurityCode,
              expirationDate: payload.expirationDate,
              cardName: payload.cardName,
              cardDNI: payload.cardDNI
            }
          );
        }
        if (subscribeRes.status != 201) {
          const err = errors.handleHTTPError(subscribeRes);
          throw err;
        }
        return subscribeRes.data;
      } catch (err) {
        throw err;
      }
    },
    async unsubscribe({ commit, state }, payload) {
      try {
        const unsubscribeRes = await Vue.prototype.$axios.delete(
          `/subscriptions/${state.subscription.id}/subscribers/${state.customer.id}`
        );
        if (unsubscribeRes.status != 200)
          throw errors.handleHTTPError(unsubscribeRes);
        else return unsubscribeRes.data.message;
      } catch (error) {
        throw error;
      }
    },
    async activate({ commit }, payload) {
      try {
        const activateRes = await Vue.prototype.$axios.post(
          `/subscriptions/${this.state.subscriber.subscription.id}/subscribers/${this.state.subscriber.customer.id}/activate`
        );
        if (activateRes.status != 201)
          throw errors.handleHTTPError(
            activateRes,
            "Hubo un error al intentar reactivar al cliente."
          );
        else return "Se reactivo la suscripción del cliente.";
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {
    subscription: state => {
      return state.subscription;
    },
    customer: state => {
      return state.customer;
    },
    cardDetails: state => {
      return state.cardDetails;
    }
  }
};
